import "./CategoryPage.scss";

import React from "react";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  Link,
  Typography
} from "@mui/material";
import { Grid2 } from "@mui/material";

import Breadcrumb from "../../shared/components/breadcrumb/Breadcrumb";
import {
  FeatureToggle,
  NewsReleasesByCategory
} from "../../shared/models/app-data-model";

export type CategoryPageProps = {
  content: NewsReleasesByCategory[];
  categoryUrl: string;
  categoryTitle: string;
  limit :number, 
  skip :number, 
  numPages :number, 
  currentPage :number,
  pageUrl: string;
  featureToggles: FeatureToggle[];
};

const CategoryPage: React.FC<CategoryPageProps> = ({ content, categoryUrl, categoryTitle, limit, skip, numPages, currentPage, pageUrl , featureToggles}: CategoryPageProps) => {
  
  const breadcrumb = <><Breadcrumb url={categoryUrl} featureToggles={featureToggles}></Breadcrumb></>;

  const isFirst = currentPage === 1;
  const isLast = currentPage === numPages;
  let  prevPage = pageUrl;
  let nextPage =pageUrl;
  if(!isFirst)
    prevPage = categoryUrl + "/Page-" + (currentPage - 1).toString();

  if(!isLast)
    nextPage =  categoryUrl + "/Page-" + (currentPage + 1).toString();

  const begin = skip;
  const end = skip + limit;

  const currentContent = content.slice(begin, end);

  const newsReleaseCategory = (
    <>
      {currentContent.map(x =>
        <>        
          <Card className='news-release-card'>
            <CardContent className='content'>
              <Typography variant='h6' className='content-title'>
                <a key={x.newsReleaseCard.uid} href={x.newsReleaseCard.url}>{x.newsReleaseCard.seo.title}</a>
              </Typography>
              <Typography variant='body2'>
                <a className="category-link" href={categoryUrl}>{categoryTitle}</a>
              </Typography>
              <Typography variant="body1" className ="card-description">
                {x.newsReleaseCard.seo.description}
              </Typography>
            </CardContent>
            <CardActions disableSpacing className="card-actions">
              <Button key={x.newsReleaseCard.uid} variant="contained" className="action-button" href={x.newsReleaseCard.url}>
                Read article
              </Button>
            </CardActions>
          </Card>
       </>
      )}
    </>
   );

  return (    
    <>
    <Grid2 container rowSpacing={2} columnSpacing={3} className='category-page' maxWidth="xl">
      <Grid2 size="grow" className="hero_wrapper">
        <Grid2 size="grow" className='hero'>
          <Box className="content">   
            <Typography variant='h1'>
              {categoryTitle}
            </Typography>
          </Box>
        </Grid2>
      </Grid2>
      <Grid2 size={{ xs: 12}} container className='page-info'>
          <Grid2 container className='breadcrumb'>
          {breadcrumb}
          </Grid2>
        </Grid2>

      <Grid2 component="main" container className="">
        <Grid2 size="grow" className="article-container">
          {newsReleaseCategory}
        </Grid2>
      </Grid2>
      <Grid2 size="grow" className="pagination">
        {numPages > 1 &&(
          <>
          <IconButton className="pageButton" component={Link} href={prevPage} aria-label="Back">
              <ArrowBackIosIcon />
          </IconButton>
          {Array.from({ length: numPages }, (_, i) => (
              (i + 1)  !== currentPage && (
                <Button className="pageButton" component={Link} href={categoryUrl + "/Page-" + (i+1).toString()}>{i+1}</Button>
              ) ||
              (
                <Button className="pageButton" component={Link} variant="contained" href={categoryUrl + "/Page-" + (i+1).toString()}>{i+1}</Button>
              )
          ))}
          <IconButton className="pageButton" component={Link} href={nextPage} aria-label="Forward">
            <ArrowForwardIosIcon />
          </IconButton>
          </>
        )}
      </Grid2>
    </Grid2>
    </>
  );
};

export default CategoryPage;